enum BackendAttachmentType {
  GIF = 'gif',
  FILE = 'file',
  VIDEO = 'video',
}

export default BackendAttachmentType
